<template>
  <span class="dot inline-block rounded-full h-[0.3rem] w-[0.3rem] bg-current" />
  <span class="dot inline-block rounded-full h-[0.3rem] w-[0.3rem] bg-current mx-1" />
  <span class="dot inline-block rounded-full h-[0.3rem] w-[0.3rem] bg-current" />
</template>

<style scoped>
.dot {
  animation: dot linear 0.9s infinite;
}

.dot:nth-of-type(2) {
  animation-delay: 0.3s;
}

.dot:nth-of-type(3) {
  animation-delay: 0.6s;
}

@keyframes dot {
  0% {
    opacity: 0.25;
  }

  100% {
    opacity: 1;
  }
}
</style>
